import { Button, Tooltip } from '@chakra-ui/react';
import React from 'react';

import type { SlotProps } from '../../interface/slotProps';
import { useCaseNotesActivityPanel } from '../CaseNotesActivityPanelContext';

const ACTIVITY_LABEL = 'Activity';

const HistoryIcon: React.FC<{ size?: number }> = ({ size = 14 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="9" />
    <polyline points="12,7 12,12 16,14" />
  </svg>
);

// Shares the single panel with CaseNotesAction via context; only signals intent.
export const ActivityAction: React.FC<SlotProps> = () => {
  const { open } = useCaseNotesActivityPanel();

  return (
    <Tooltip label={ACTIVITY_LABEL} placement="bottom" openDelay={300}>
      <Button
        data-testid="activity-icon"
        aria-label={ACTIVITY_LABEL}
        onClick={() => open('activity')}
        variant="unstyled"
        flexShrink={0}
        display="grid"
        placeItems="center"
        w="26px"
        h="26px"
        minW="26px"
        p={0}
        borderRadius="7px"
        bg="#fafaf7"
        color="#6b6258"
        border="1px solid #ece6dd"
        _hover={{ filter: 'brightness(0.94)' }}
        sx={{ '& svg': { display: 'block' } }}
      >
        <HistoryIcon />
      </Button>
    </Tooltip>
  );
};
